var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDrivePrice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 17.5,
    width: 32,
    height: 34,
    rx: 2,
    fill: "#3A7EFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3232 67.3326C44.5672 67.9996 43.4329 67.9996 42.6768 67.3326L20.9668 48.1785C19.585 46.9594 20.4472 44.6787 22.2899 44.6787L65.7101 44.6788C67.5528 44.6788 68.415 46.9594 67.0333 48.1785L45.3232 67.3326Z",
    fill: "#3A7EFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6645 46.6875L38.3555 41.4175H36.5365V39.9215H37.9815L36.6725 34.6515H38.7125L39.8855 39.9215H41.7215L42.9965 34.6515H45.0025L46.2435 39.9215H48.1135L49.2865 34.6515H51.3265L50.0175 39.9215H51.4285V41.4175H49.6435L48.3345 46.6875H46.2265L44.9345 41.4175H43.0645L41.7725 46.6875H39.6645ZM40.2085 41.4175L40.7185 43.6955H40.8205L41.3645 41.4175H40.2085ZM43.4385 39.9215H44.5605L44.0505 37.8135H43.9485L43.4385 39.9215ZM46.6005 41.4175L47.1445 43.6955H47.2805L47.7905 41.4175H46.6005Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDrivePrice);
export default __webpack_public_path__ + "static/media/IcDrivePrice.19fd4f0d303dd2046afa0302b0e11cd5.svg";
export { ForwardRef as ReactComponent };